import http from './http';

export default {
    /**
     * Get login an user.
     * @param {String} usuario 
     * @param {String} password 
     */
    login (usuario, password) {
        return http.post('/auth/login', { usuario, password })
    },

    /**
     * Start password recovery flow.
     * @param {String} usuario 
     * @param {String} url 
     * @param {String} vista 
     * @returns {Promise}
     */
    password_recovery(usuario, url, vista = 'base') {
        return http.post('/auth/recovery', { usuario, url, vista })
    },

    /**
     * Reset the password.  
     * @param {Object} payload 
     * @returns {Promise}
     */
    password_reset(payload) {
        return http.put('/auth/recovery', payload)
    },

    /**
     * Refresh authentication token.
     * @param {String} token 
     * @returns {Promise}
     */
    refresh(token) {
        return http.post('auth/refresh', { token })
    },
}